import { render } from "./SecuritiesDocs.vue?vue&type=template&id=339c4b56&scoped=true&ts=true"
import script from "./SecuritiesDocs.vue?vue&type=script&lang=ts"
export * from "./SecuritiesDocs.vue?vue&type=script&lang=ts"

import "./SecuritiesDocs.vue?vue&type=style&index=0&id=339c4b56&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339c4b56"]])

export default __exports__